import React, { ReactElement, useState } from 'react';
import { createGlobalStyle } from 'styled-components';

import { Typography, Flex, Box, Row, Col } from 'components';

import Term from './Term';

import {
  Wrapper,
  ContentWrapper,
  //   Header,
  //   HeaderContent,
  // DownloadIcon,
  // DocumentTypography,
  Square,
  LinkButton,
  // LinkButtonDisabled,
  TermsLink,
  // AlertIcon,
  //   HeaderWrapper,
  // FlexDownload,
  // MobileBreak,
  Header,
  Overlay,
  SquareLines,
  // Plus,
} from './styles';

const GlobalStyle = createGlobalStyle`
    body {
        background: ${({ theme }) => theme.colors.black80};
    }
`;

const Imersao = (): ReactElement => {
  const [showTerm, setShowTerm] = useState(false);

  const hideTerm = () => {
    setShowTerm(false);
  };

  return (
    <>
      {showTerm && <Term hideTerm={hideTerm} />}

      <Wrapper>
        <Header>
          <Overlay pt={{ m: 40, t: 100, d: 150 }} pr={{ m: 40, t: 60, d: 100 }} pb={{ m: 40, t: 60, d: 100 }} pl={{ m: 60, t: 120, d: 230 }}>
            <Flex zIndex={15} flexDirection="column">
              <Typography type="type6" fontWeight="bold" color="white" upper style={{ position: 'relative' }}>
                <SquareLines />
                CERTIFICAÇÃO
              </Typography>

              <Typography type="type10" fontWeight="bold" color="white" mt={{ m: 1, t: '10px' }}>
                Curso Preparatório ANCORD
              </Typography>

              <Typography color="white" type="type2" mt={{ m: 3, t: 20, d: 40 }} lineHeight={1.3}>
                Os AAIs (Agentes Autônomos de Investimentos) vêm cumprindo papel transformador no mercado financeiro brasileiro. Eles levam as mais
                diversas possibilidades de investimentos para os brasileiros, ajudando-os a utilizar o mercado financeiro como um meio para a
                realização dos seus sonhos.
                <br />
                <br />
                Cabe aos AAIs entenderem o momento de vida dos seus clientes, seus objetivos, anseios e perfis de risco. Ao entenderem, com precisão,
                o que seus clientes precisam, os AAIs utilizam os mais variados produtos e serviços existentes no mercado financeiro para melhor
                atendê-los. Trata-se de uma combinação de empatia, comunicação e conhecimento técnico.
                <br />
                <br />
                Não é à toa que a demanda por agentes autônomos tem aumentado muito no mercado. O exercício dessa profissão se dá por todo o Brasil,
                não há limites geográficos.
              </Typography>
            </Flex>
          </Overlay>
        </Header>

        <Flex bg="dark_350" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Row>
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" pr={4} justifyContent="flex-start">
                  <Typography upper color="white" fontWeight="bold">
                    Conhecimento
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>Atividade do AAI, Lavagem de Dinheiro, Sistema Financeiro Nacional;</li>
                      <li>Renda Variável, Renda Fixa e Fundos de Investimentos;</li>
                      <li>Matemática financeira;</li>
                      <li>Procedimentos Operacionais;</li>
                      <li>Derivativos;</li>
                      <li>E muito mais.</li>
                    </ul>
                  </Typography>
                </Flex>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" justifyContent="flex-start" mt={{ m: 50, d: 0 }}>
                  <Typography upper color="white" fontWeight="bold">
                    Detalhes do curso
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>Objetivo: aprovação na Certificação ANCORD;</li>
                      <li>Correlação de conhecimento teórico com as práticas do mercado;</li>
                      <li>Mais de 150 videoaulas;</li>
                      <li>23 módulos;</li>
                      <li>23 e-books;</li>
                      <li>Centenas de exercícios e simulados;</li>
                      <li>Tempo de acesso ao curso: 6 meses.</li>
                    </ul>
                  </Typography>
                </Flex>
              </Col>
            </Row>
          </ContentWrapper>
        </Flex>

        <Flex bg="white" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Flex flexDirection="column">
              <Typography color="black80" upper>
                Formato
              </Typography>
              <Typography type="type7" color="black" fontWeight="bold" mt={1}>
                Metodologia de aprendizagem
              </Typography>
            </Flex>

            <Row gutter={50} mt={{ m: 3, d: 5 }} alignItems="flex-start">
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Typography color="black80" lineHeight={1.5}>
                  O conteúdo para a Certificação ANCORD foi organizado em módulos. Os módulos são compostos por videoaulas, <em>e-book(s)</em>,
                  exercícios e simulados.
                  <br />
                  <br />
                  Você tem toda a liberdade para assistir às aulas quantas vezes quiser, no horário que lhe for mais conveniente e de onde você
                  preferir.
                  <br />
                  <br />
                  Nosso time de professores estará em contato direto com você por meio de lives. A nossa equipe de suporte estará sempre à sua
                  disposição para sanar suas dúvidas. Ao final deste curso, você estará mais do que preparado para realizar o exame.
                </Typography>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }} mt={{ m: 4, t: 0 }}>
                <Typography fontWeight="bold">Videoaulas</Typography>
                <Typography mt={1}>As videoaulas estão organizadas em módulos. Você aprenderá com especialistas do mercado financeiro.</Typography>

                <Typography fontWeight="bold" mt={4}>
                  Exercícios e Simulados
                </Typography>
                <Typography mt={1}>
                  Ao final de cada módulo, você poderá fazer exercícios para reforçar o seu aprendizado. Você poderá, ainda, simular o dia da prova
                  por meio de nossos simulados.
                </Typography>

                <Typography fontWeight="bold" mt={4}>
                  <em>E-books</em>
                </Typography>
                <Typography mt={1}>
                  Nossos <em>e-books</em> prepararão você muito mais do que para a prova. O material produzido é riquíssimo, com muita profundidade e
                  cheio de detalhes.
                </Typography>
              </Col>
            </Row>
          </ContentWrapper>
        </Flex>

        <ContentWrapper>
          <Flex mt={{ m: 30, d: 120 }} px={{ m: 20, d: 0 }} pt={{ m: 20, d: 0 }} flexDirection="column">
            <Typography type="type7" color="white" fontWeight="bold" upper>
              Forma de
            </Typography>

            <Typography type="type10" color="white" fontWeight="bold" upper>
              Pagamento
            </Typography>
          </Flex>

          <Flex mx={{ d: 0 }} mt={{ m: 20, d: 30 }}>
            <Row gutter={30}>
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex mx={{ m: 20, d: 0 }} flexDirection="column" px={{ m: 30, d: 50 }} pb={{ m: 30, d: 40 }} borderRadius={4} bg="dark_350">
                  <Flex flexDirection="column">
                    <Square />

                    <Typography type="type2" color="white" fontWeight="regular" upper mt={2}>
                      Certificação
                    </Typography>

                    <Typography type="type5" color="white" fontWeight="bold" upper mt={1} lineHeight={1.2}>
                      Curso Preparatório ANCORD
                    </Typography>

                    <Typography type="type0" color="white25" mt={1}>
                      Curso on-line
                    </Typography>
                  </Flex>

                  <Flex flexDirection="column" flexGrow={0} mt={{ m: 3, d: 6 }}>
                    <Typography type="type5" color="white" fontWeight="bold" mt={1}>
                      12x de R$ 61,28
                    </Typography>

                    <Typography type="type1" color="white" mt={1} mb={3}>
                      Ou à vista R$ 600,00 sem juros
                    </Typography>

                    <Flex flexDirection="column">
                      <LinkButton target="_blank" href="https://checkout.premepay.com/ks8pW7">
                        Comprar
                      </LinkButton>

                      <Typography lineHeight="1.3" type="type0" color="white25" mt={3}>
                        Ao clicar em comprar, declaro que aceito os <TermsLink onClick={() => setShowTerm(true)}>termos de uso</TermsLink> do produto.
                      </Typography>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Flex>

          <Box flexGrow={1} textAlign="center" pt={{ m: 40, d: 100 }} pb="20px">
            <Typography lineHeight="1.4" type="type0" color="#9F9F9F">
              © Todos os direitos reservados a MELVER LTDA.
            </Typography>
          </Box>
        </ContentWrapper>
      </Wrapper>
      <GlobalStyle />
    </>
  );
};
export default Imersao;
